import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookCellStatusBarService = ( createDecorator('notebookCellStatusBarService'));
export { INotebookCellStatusBarService };
